import { createStyles, makeStyles, Paper, SvgIconTypeMap, Theme, Typography } from '@material-ui/core';
import React from 'react';
import { OverridableComponent } from '@material-ui/core/OverridableComponent';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        // ── Section cards ─────────────────────────────────────────────────────
        sectionCard: {
            // border: '1px solid #e0e0e0',
            // borderRadius: '8px',
            padding: '16px',
            // background: '#fff',
            display: 'flex',
            flexDirection: 'column' as const,
            gap: theme.spacing(2),
        },
        sectionHead: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: '10px',
            justifyContent: 'space-between',
        },
        sectionHeadLeft: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: '10px',
            flex: 1,
            minWidth: 0,
        },
        sectionHeadRight: {
            flexShrink: 0,
            display: 'flex',
            alignItems: 'center',
        },
        sectionIcon: {
            width: '32px',
            height: '32px',
            borderRadius: '6px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            fontSize: '16px',
        },
        sectionTitle: {
            fontSize: '12px',
            letterSpacing: '0.07em',
            textTransform: 'uppercase' as const,
            fontWeight: 600,
            marginBottom: '3px',
        },
        sectionDesc: {
            fontSize: '13px',
            color: theme.palette.text.secondary,
            lineHeight: 1.5,
        },
    }),
);


interface FormSectionCardProps extends React.PropsWithChildren<{}> {
    title: string;
    description?: string;
    color?: string;
    bgColor?: string;
    icon?: OverridableComponent<SvgIconTypeMap>;
    headerAction?: React.ReactNode;
    useDefaultTitleColor?: boolean;
}

export function FormSectionCard(props: FormSectionCardProps) {

    const classes = useStyles();

    return (
        <Paper 
            className={classes.sectionCard}
        >
            <div className={classes.sectionHead}>
                <div className={classes.sectionHeadLeft}>
                    {props.icon ? (
                        <div 
                            className={`${classes.sectionIcon}`}
                            style={{ 
                                backgroundColor: props.bgColor ?? '#e0e0e0',
                                color: props.color ?? '#000' 
                            }}
                        >
                            <props.icon 
                                fontSize="small"
                            />
                        </div>
                    ) : null}
                    <div>
                        <Typography
                            className={`${classes.sectionTitle}`}
                            style={props.useDefaultTitleColor ? undefined : { color: props.color ?? '#000' }}
                        >
                            {props.title}
                        </Typography>
                        {props.description && (
                            <Typography className={classes.sectionDesc}>
                                {props.description}
                            </Typography>
                        )}
                    </div>
                </div>
                {props.headerAction && (
                    <div className={classes.sectionHeadRight}>
                        {props.headerAction}
                    </div>
                )}
            </div>
            <div>
                {props.children}
            </div>
        </Paper>
    );
};